import React, { FC, ReactNode, useEffect, useState } from 'react';

import { usePlatformHotkeys as useHotkeys } from '@/hooks/usePlatformHotkeys';

interface KeyboardShortcutsWrapperProps {
    children?: ReactNode;
    filters: any;
    setFilters: any;
}

const KeyboardShortcutsWrapper: FC<KeyboardShortcutsWrapperProps> = ({
    children,
    filters,
    setFilters,
}): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    // Disables Saving Page as HTML (default logic)
    useHotkeys('meta+backspace', () => {
        // if (filters && Object.keys(filters)?.length !== 0) {
        setFilters({});
        // }
    });

    return <>{children}</>;
};

export default KeyboardShortcutsWrapper;
